import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCallbackForm } from 'shared/regions/services/fetchCallbackForm';
import { TFetchFormParams } from 'shared/common/types/form';
import { IThunkApi } from 'shared/common/types/redux';

export const sendForm = createAsyncThunk<string, TFetchFormParams, IThunkApi>(
  'form/sendForm',
  async (params, _thunkApi) => {
    const { rejectWithValue, extra } = _thunkApi;

    try {
      const response = await fetchCallbackForm(extra, params);

      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
